import Annotation from "./annotation";
import { setLineStyle } from "../canvasUtils";
import { getZoom } from "../geometry";

export default class HVFViewFinder extends Annotation {
  constructor(){
    super();
    this.x = 0;
    this.y = 0;
    this.width = 0;
    this.height = 0;
    this.lineWidth = 3;
    this.color = "#00b0f0";
    this.backgroundColor = "rgba(0,176,240,0.3)";
  }

  draw(ctx) {
    if (!this.width || !this.height) return;
    
    ctx.beginPath();
    ctx.fillStyle = this.backgroundColor;
    ctx.fillRect(this.x, this.y, this.width, this.height);
    setLineStyle(ctx, this);
    ctx.strokeRect(this.x, this.y, this.width, this.height);
    ctx.closePath();
  }

  updateViewFinder(controlSize, controlTransform, imgSize, canvasSize, scroll){
    this.width = imgSize.w * controlTransform.zoom;

    let cz = controlTransform.zoom;
    let smallImgSize = { w: imgSize.w * cz, h: imgSize.h * cz };
    let z = getZoom(smallImgSize, canvasSize);
    let smallCanvasSize = { w: canvasSize.w * z, h: canvasSize.h * z };

    this.width = smallCanvasSize.w;
    this.height = smallCanvasSize.h;

    this.x = (controlSize.w - smallCanvasSize.w) / 2;

    let top = smallImgSize.h - this.height;
    let minTop = (controlSize.h - smallImgSize.h) / 2;
    this.y = minTop + scroll * top;

    this.signalReady();
  }
}